import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
import one from '../assets/one.jpg'
import trade from '../assets/trade.jpg'
import tax from '../assets/tax.jpg'
import labour from '../assets/labour.jpg'
import msme from '../assets/msme.jpg'
import firm from '../assets/firm.jpg'

import Navbar from "./navbar";
import Footer from "./footer";






function ServicesPage() {
  // Initialize AOS on component mount
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // Initialize AOS with options
  }, []);

  return (
    <div className="text-gray-800 bg-gradient-to-tr from-white via-orange-200 to-white font-poppins min-h-screen">
      {/* Navigation Bar */}

      <Navbar/>

      {/* Service Sections with Animations */}
      <div className="relative  px-9 w-full h-screen" data-aos="fade-up">
        <div className="absolute  left-0 w-full h-full flex flex-col items-center justify-center z-10">
          <h3 className="text-4xl font-bold text-white">FOOD LICENCE</h3>
          <p className="mt-4 text-lg text-white max-w-2xl text-center">
            Get your food license to operate legally in the food industry.
          </p>
        </div>
        <img
          src={one}
          alt="Food License"
          className="w-full h-full object-cover absolute top-0 left-0 z-0"
        />
      </div>

      {/* Second Section */}
      <div className="relative  px-9 w-full h-screen" data-aos="fade-up">
        <div className="absolute  left-0 w-full h-full flex flex-col items-center justify-center z-10">
          <h3 className="text-4xl font-bold text-white">TRADE LICENCE</h3>
          <p className="mt-4 text-lg text-white max-w-2xl text-center">
            Apply for your trade license to start your business operations seamlessly.
          </p>
        </div>
        <img
          src={trade}
          alt="Trade License"
          className="w-full h-full object-cover absolute top-0 left-0 z-0"
        />
      </div>

      {/* Second Section */}
      <div className="relative  px-9 w-full h-screen" data-aos="fade-up">
        <div className="absolute top-4 left-0 w-full h-full flex flex-col items-center justify-center z-10">
          <h3 className="text-4xl font-bold text-white">GST Return</h3>
          <p className="mt-4 text-lg text-white max-w-2xl text-center">
            Ensure compliance by filing your GST return with us. We offer quick and reliable services to help you with your GST filings.
          </p>

        </div>
        <img
          src={tax}
          alt="Trade License"
          className="w-full h-full object-cover absolute top-0 left-0 z-0"
        />
      </div>



      {/* Third Section */}
      <div className="relative  px-9 w-full h-screen" data-aos="fade-up">
        <div className="absolute top-4 left-0 w-full h-full flex flex-col items-center justify-center z-10">
          <h3 className="text-4xl font-bold text-white">MSME REGISTRATION</h3>
          <p className="mt-4 text-lg text-white max-w-2xl text-center">
            Get your MSME registration done with ease. We guide you through the entire process to ensure your business is recognized and eligible for government benefits.
          </p>


        </div>
        <img
          src={msme}
          alt="Food License"
          className="w-full h-full object-cover absolute top-0 left-0 z-0"
        />
      </div>


      {/* Third Section */}
      <div className="relative  px-9 w-full h-screen" data-aos="fade-up">
        <div className="absolute top-4 left-0 w-full h-full flex flex-col items-center justify-center z-10">
          <h3 className="text-4xl font-bold text-white">FIRM REGISTRATION</h3>
          <p className="mt-4 text-lg text-white max-w-2xl text-center">
            Register your firm with us for a smooth and hassle-free process. We assist in getting your firm legally recognized, ensuring compliance with all regulatory requirements.
          </p>

        </div>
        <img
          src={firm}
          alt="Food License"
          className="w-full h-full object-cover absolute top-0 left-0 z-0"
        />
      </div>

      {/* Fourth Section */}
      <div className="relative  px-9 w-full h-screen" data-aos="fade-up">
        <div className="absolute top-4 left-0 w-full h-full flex flex-col items-center justify-center z-10">
          <h3 className="text-4xl font-bold text-white">LABOUR LICENCE</h3>
          <p className="mt-4 text-lg text-white max-w-2xl text-center">
            Obtain your Labour Licence to ensure compliance with labor laws and regulations. We guide you through the entire process, ensuring a smooth and hassle-free experience.
          </p>


        </div>
        <img
          src={labour}
          alt="Trade License"
          className="w-full h-full object-cover absolute top-0 left-0 z-0"
        />
      </div>

 <Footer/>
    </div>
  );
}

export default ServicesPage;
